import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ProjectListViewComponent } from './project-list/views/project-list-view/project-list-view.component';
import { PageNotFoundViewComponent } from './core/components/page-not-found-view/page-not-found-view.component';
import { LoginViewComponent } from './auth/views/login-view/login-view.component';
import { AuthenticatedGuard } from './core/guards/authenticated.guard';
import { NonAuthenticatedGuard } from './core/guards/non-authenticated.guard';
import { UserSettingsViewComponent } from './user-account/views/user-settings-view/user-settings-view.component';
import { EditProjectViewComponent } from './project/views/edit-project-view/edit-project-view.component';
import { canDeactivateFormComponent } from './core/guards/deactivate-form.component';
import { LogoutViewComponent } from './auth/views/logout-view/logout-view.component';
import { ConnectionErrorViewComponent } from './core/components/connection-error-view/connection-error-view.component';
import { GeneralErrorViewComponent } from './core/components/general-error-view/general-error-view.component';
import { CreateProjectViewComponent } from './project/views/create-project-view/create-project-view.component';
import { ProductViewComponent } from './project/views/product-view/product-view.component';
import { ProjectPricesViewComponent } from './project/views/project-prices-view/project-prices-view.component';
import { RecoverPasswordViewComponent } from './auth/views/recover-password/recover-password-view.component';
import { ResetPasswordViewComponent } from './auth/views/reset-password/reset-password-view.component';
import { ChangePasswordViewComponent } from './user-account/views/change-password-view/change-password-view.component';
import { AddLineViewComponent } from './project/views/addline-view/addline-view.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'projects',
    pathMatch: 'full'
  },
  {
    path: 'login',
    component: LoginViewComponent,
    canActivate: [NonAuthenticatedGuard]
  },
  {
    path: 'logout',
    component: LogoutViewComponent
  },
  {
    path: 'password',
    children: [
      {
        path: 'recover',
        pathMatch: 'full',
        component: RecoverPasswordViewComponent,
        canActivate: [NonAuthenticatedGuard]
      },
      {
        path: 'reset',
        pathMatch: 'full',
        component: ResetPasswordViewComponent,
        canActivate: [NonAuthenticatedGuard]
      }
    ]
  },
  {
    path: 'projects',
    children: [
      {
        path: '',
        pathMatch: 'full',
        component: ProjectListViewComponent,
        canActivate: [AuthenticatedGuard]
      },
      {
        path: 'new',
        component: CreateProjectViewComponent,
        canActivate: [AuthenticatedGuard]
      },
      {
        path: 'user-settings',
        component: UserSettingsViewComponent,
        canActivate: [AuthenticatedGuard],
        canDeactivate: [canDeactivateFormComponent]
      },
      {
        path: 'change-password',
        component: ChangePasswordViewComponent,
        canActivate: [AuthenticatedGuard],
        canDeactivate: [canDeactivateFormComponent]
      },
      {
        path: ':id',
        children: [
          {
            path: '',
            pathMatch: 'full',
            component: EditProjectViewComponent,
            canActivate: [AuthenticatedGuard]
          },
          {
            path: 'products',
            component: ProductViewComponent,
            canActivate: [AuthenticatedGuard]
          },
          {
            path: 'products/addline',
            component: AddLineViewComponent,
            canActivate: [AuthenticatedGuard]
          },
          {
            path: 'prices',
            component: ProjectPricesViewComponent,
            canActivate: [AuthenticatedGuard]
          }
        ]
      }
    ]
  },

  {
    path: 'connection-error',
    component: ConnectionErrorViewComponent
  },
  {
    path: 'general-error',
    component: GeneralErrorViewComponent
  },
  {
    path: '**',
    pathMatch: 'full',
    component: PageNotFoundViewComponent,
    canActivate: [AuthenticatedGuard]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' })],
  exports: [RouterModule]
})
export class AppRoutingModule {}
